globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.SearchFilter = (function()
{
  function SearchFilter($html) {
    if($html.length === 1) {
      this.$html             = $html;
      this.classTarget       = this.$html.data('filter-target');
      this.classContainer    = this.$html.data('container');
      this.removeAccent      = this.$html.data('noaccent');
      this.$objects          = this.setObjects();
    }
  }

  SearchFilter.initFilters = function($html) {
    $.each($html, function() {
      var filter = new SearchFilter($(this));
      filter.init();
    });
  }

  SearchFilter.prototype =
  {
    // Private
    init : function(){
      var me = this;
      me.$html.keyup(function(){
        var search = $(this).val();
        (search != '') ? me.render(search) : me.clear();
      });
    },
    setObjects : function(){
      if(this.classContainer != ''){
        return $(this.classContainer).find(this.classTarget);
      } else {
        return $(this.classTarget);
      }
    },
    render : function(textInput) {
      var me        = this,
          textInput = me.removeAccent ? _noAccent(textInput) : textInput;

      $.each(me.$objects, function(){
        var $this       = $(this),
            contentText = $.trim($this.data('content') || $this.text()),
            regex       = new RegExp(textInput, 'i');

        if(contentText.match(regex)){
          $this.show();
        } else {
          $this.hide();
        }
      });
    },
    clear : function(){
      this.$objects.show();
    }
  }

  function _noAccent(s) {
    var r = s.toLowerCase();
    r = r.replace(new RegExp(/\s/g),"");
    r = r.replace(new RegExp(/[àáâãäå]/g),"a");
    r = r.replace(new RegExp(/æ/g),"ae");
    r = r.replace(new RegExp(/ç/g),"c");
    r = r.replace(new RegExp(/[èéêë]/g),"e");
    r = r.replace(new RegExp(/[ìíîï]/g),"i");
    r = r.replace(new RegExp(/ñ/g),"n");
    r = r.replace(new RegExp(/[òóôõö]/g),"o");
    r = r.replace(new RegExp(/œ/g),"oe");
    r = r.replace(new RegExp(/[ùúûü]/g),"u");
    r = r.replace(new RegExp(/[ýÿ]/g),"y");
    r = r.replace(new RegExp(/\W/g),"");
    return r;
  }

  return SearchFilter;
})();
